
































































































































































































import _ from "lodash";
import { Prop, Component, Vue } from "vue-property-decorator";
import { Company, Office, CompanyType } from "@/api/company-api";
import SwitchButton from "@/components/SwitchButton.vue";
import VDelete from "@/components/VDelete.vue";
import Decimal from "decimal.js";

@Component({
  components: {
    VDelete,
    SwitchButton
  }
})
export default class CompanyEdit extends Vue {
  @Prop({ required: true }) company!: Company;
  @Prop({ required: true }) office!: Office;
  @Prop({ type: Boolean, default: false }) removable!: boolean;

  companyTypeOptions = [
    { text: "法人", value: CompanyType.Corporation },
    { text: "個人", value: CompanyType.Individual },
    { text: "エンドユーザー", value: CompanyType.EndUser }
  ];

  dayOptions = _.range(1, 32);

  get family() {
    return this.company.family;
  }

  defaultProfitRate = String(
    new Decimal(this.office.profitRate ? this.office.profitRate : 0).mul(100)
  );

  get profitRate(): string {
    if (this.office.profitRate === null) {
      return "";
    }
    return String(new Decimal(this.office.profitRate).mul(100));
  }

  set profitRate(profitRate: string) {
    if (!profitRate) {
      this.office.profitRate = null;
      return;
    }
    this.office.profitRate = new Decimal(profitRate).div(100).toNumber();
  }

  checkClient(checkBoxStatus: any) {
    if (checkBoxStatus) {
      this.office.profitRate = 0;
    } else {
      const defaultProfitRate = new Decimal(this.defaultProfitRate)
        .div(100)
        .toNumber();
      this.office.profitRate = defaultProfitRate ? defaultProfitRate : 0.2;
    }
  }

  status = "";

  submit() {
    this.status = "progressing";
    this.$emit("ok");
  }

  cancel() {
    this.$emit("cancel");
  }

  remove() {
    this.$emit("remove");
  }

  addBankAccount() {
    this.office.bankAccounts.push({
      bank: "",
      branch: "",
      account: "",
      account_type: "",
      account_number: ""
    });
  }
}
